// Copyright (c) StrangeBee 2024

import { ObjectTypeV1, ReportTemplateWidgetEnum } from 'thehive-sdk';

export const mapKindToEntity: Partial<Record<ReportTemplateWidgetEnum, ObjectTypeV1>> = {
    ObservableTable: ObjectTypeV1.OBSERVABLE,
    AlertTable: ObjectTypeV1.ALERT,
    TaskTable: ObjectTypeV1.TASK,
    TTPTable: ObjectTypeV1.PROCEDURE,
    TaskList: ObjectTypeV1.TASK,
    CustomFields: ObjectTypeV1.CUSTOM_FIELD,
};

export const mapListKindToEntity: Partial<Record<ReportTemplateWidgetEnum, ObjectTypeV1>> = {
    TaskList: ObjectTypeV1.TASK,
};

export const sortColumns = (fieldA: string, fieldB: string): number => {
    if (fieldA.startsWith('_') && !fieldB.startsWith('_')) {
        return 1;
    }
    if (fieldB.startsWith('_') && !fieldA.startsWith('_')) {
        return -1;
    }
    return fieldA.localeCompare(fieldB);
};
